<template>
  <div class="top-panel">
    <img class="img" :src="!china ? require('../assets/logo-vertical-en.png') : require('../assets/logo-vertical.png')"
      @click="$routeChange('home')" />
    <!-- <div style="height: 36px; display: inline-block; line-height: 36px;"></div> -->
    <!-- <span class="top-title" @click="$routeChange('home')" :style="{ fontSize: (china ? '13px' : '10px') }">
      {{ pageTitle || lang.pageHeader }}</span> -->
    <!-- <icon name="wap-nav" class="top-icon" /> -->
    <span class="top-icon">
      <!--   <icon
        v-if="$$state.showNavPanel"
        name="cross"
        style="vertical-algin: middle; margin-top: 3px; font-size: 22px;"
        @click="toggleShowNav(false)"
      /> -->
      <!-- <icon v-else name="wap-nav" @click="toggleShowNav(true)" /> -->
      <img v-if="china" @click="toggleLang('en')" src="@/assets/icon/en.png"
        style="width:22px; height: 22px; vertical-align: middle; margin-right: 15px;">
      <img v-else @click="toggleLang('cn')" src="@/assets/icon/cn.png"
        style="width:22px; height: 22px; vertical-align: middle; margin-right: 15px;">

      <img v-if="showNavPanel" @click="toggleShowNav(false)" src="@/assets/icon/menu-close.png"
        style="width:22px; height: 22px; vertical-align: middle;">
      <img v-else src="@/assets/icon/menu.png" style="width:22px; height: 22px; vertical-align: middle;"
        @click="toggleShowNav(true)">
    </span>
  </div>
</template>
<script>
import mapStore from '@/mixins/mapStore'
export default {
  name: "pageHeader",
  mixins: [
    mapStore('', {
      states: ['showNavPanel'],
      getters: ['lang', 'china'],
      mutations: ['setState']
    })
  ],
  props: {
    pageTitle: {
      type: String
    }
  },
  methods: {
    toggleShowNav(value) {
      this.setState({ key: 'showNavPanel', value })
    },
    toggleLang(value) {
      //      this.$$state.language = value
      this.setState({ key: 'language', value })
      window.$vrm.$emit('lang-change', value)
    }
  },
};
</script>
<style lang="less" scoped>
.img {
  vertical-align: middle;
  height: 36px;
}

.top-panel {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
}

.top-title {
  .img;
  font-weight: 500;
  display: inline-block;
  margin-left: 10px;
  vertical-align: middle;
  background: white;
}

.top-icon {
  position: absolute;
  right: 15px;
  color: #76808E !important;
  top: 15px;
}
</style>